var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"d-flex justify-content-center mb-3"},[_c('b-spinner',{staticStyle:{"width":"3rem","height":"3rem"},attrs:{"label":"Large Spinner"}})],1),_vm._v(" "),_c('div',{staticClass:"d-flex justify-content-center mb-3"},[_c('strong',[_vm._v(_vm._s(_vm.textLoading)+"...")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }